<template>
  <div
    class="text-ontick-steel-900 relative w-full font-medium dark:text-gray-200"
  >
    <button
      class="border-ontick-steel-300 bg-ontick-steel-100 dark:border-ontick-carbon-500 dark:bg-ontick-graphite-500 flex w-full items-center justify-between rounded border px-3 py-2 shadow-sm focus:outline-none"
      @click="is_options_expanded = !is_options_expanded"
      @blur="is_options_expanded = false"
    >
      <span class="whitespace-no-wrap mr-2 truncate">
        <span v-if="selected" class="text-sm font-medium">{{
          selected.param_name
        }}</span>
        <span
          v-if="selected"
          class="rounded-full px-1 py-0 text-sm font-semibold"
          >(#{{ selected.param_id }})</span
        >
      </span>
      <svg
        fill="none"
        viewBox="0 0 24 24"
        stroke="#a0aec0"
        class="h-4 w-4 transform transition-transform duration-100 ease-in-out"
        :class="is_options_expanded ? 'rotate-180' : 'rotate-0'"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
    <transition
      enter-active-class="transform transition duration-300 ease-custom"
      enter-class="-translate-y-1/2 scale-y-0 opacity-0"
      enter-to-class="translate-y-0 scale-y-100 opacity-100"
      leave-active-class="transform transition duration-300 ease-custom"
      leave-class="translate-y-0 scale-y-100 opacity-100"
      leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
    >
      <ul
        v-if="is_options_expanded && parameterSettings"
        class="bg-ontick-steel-100 dark:bg-ontick-steel-500 absolute left-0 right-0 mb-4 overflow-hidden rounded shadow"
        style="z-index: 1000"
      >
        <li
          v-show="parameterSettings.length > 0"
          v-for="(param, index) in parameterSettings"
          :key="index"
          class="group hover:bg-ontick-steel-300 dark:hover:bg-ontick-steel-600 cursor-pointer px-3 py-2 transition-colors duration-100"
          @mousedown.prevent="setOption(param)"
        >
          <span class="font-normal">{{ param.param_name }}</span>
          <span
            class="first-letter: text-ontick-steel-900 rounded-full px-1 py-0 text-sm font-semibold dark:text-gray-200"
            >(#{{ param.param_id }})</span
          >
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "select-setting",
  props: {
    type: {
      type: String,
      default: "normal",
      validator: function (value) {
        return ["normal", "setting"].indexOf(value) !== -1;
      },
    },
  },
  data() {
    return {
      is_options_expanded: false,
      selected: this.selectedParameter,
    };
  },
  computed: {
    ...mapState({
      parameterSettings: (state) =>
        state.investment.parameters.parameterSettings,
      selectedParameter: (state) =>
        state.investment.parameters.selectedParameter,
    }),
    selectType() {
      return this.type == "setting" ? true : false;
    },
  },
  watch: {
    selectedParameter(value) {
      if (value) {
        this.setOption(value);
      }
    },
  },
  methods: {
    setOption(option) {
      if (option) {
        this.$emit("change", option);
        this.selected = option;
        this.is_options_expanded = false;
      }
    },
  },
};
</script>

<style scoped>
.ease-custom {
  transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
}
</style>
